module.exports = __webpack_public_path__ + "img/takeDown.3692b81d.png";